import HttpUtil, {type PageResponse, type ResultResponse} from '@/api'
import {type GetPositionLevelResponse, type ListPositionLevelResponse} from '@/api/system/positionLevel'
import {type GetPositionResponse, type ListPositionResponse} from '@/api/system/position'
import {type ListJobResponse} from '@/api/system/job'
import {type ListRoleResponse} from '@/api/system/role'
import {type FileResponse} from '@/api/global/file'
import {GetCustomerTokenTypeEnum} from "@/common/enums/mall";

export type ExternalGetTokenRequest = {
    type: GetCustomerTokenTypeEnum,
    account: string
    password: string
}

export type ExternalGetTokenResponse = {
    accessToken: string
    refreshToken: string
    expiresIn: number
}

export type GetCurrentCustomerResponse = {
    // 客户 ID
    id: string
    // 手机号码
    mobilePhone: string
    // 电子邮箱
    email: string
    name: string
    // 昵称
    nickname: string
    // 头像文件 URL
    avatarFile: FileResponse
}

export type ModifyCurrentCustomerPasswordRequest = {
    // 原密码
    oldPassword: string
    // 新密码
    newPassword: string
    // 重复新密码
    confirmNewPassword: string
}

// 系统-客户
export type UpdateCurrentCustomerRequest = {
    name?: string
    nickname?: string
    // 头像文件 ID
    avatarFileId?: string
}

export class Customer {
    static updateCurrent = async (request: UpdateCurrentCustomerRequest) => {
        return await HttpUtil.post<ResultResponse>('/customer/customer/updateCurrent', request)
    }

    static modifyCurrentPassword = async (request: ModifyCurrentCustomerPasswordRequest) => {
        return await HttpUtil.post<ResultResponse>('/customer/customer/modifyCurrentPassword', request)
    }

    static getToken = async (request: ExternalGetTokenRequest) => {
        return await HttpUtil.post<ResultResponse<ExternalGetTokenResponse>>(
            '/external/customer/customer/getToken',
            request,
        )
    }

    static getCurrent = async () => {
        return await HttpUtil.post<ResultResponse<GetCurrentCustomerResponse>>('/customer/customer/getCurrent')
    }
}
